import { Modal } from '@wyz/ui';
import { useState } from 'react';
import { IBrand } from '~/common/types';
import { IAnonymizedSupplierPlatform, ICountry } from '~/connect/types';
// eslint-disable-next-line @wyz/module/no-relative-import
import GlobalConfiguration from './best-sourcing-global-configuration';
// eslint-disable-next-line @wyz/module/no-relative-import
import SupplierConfiguration from './best-sourcing-supplier-configuration';

type Props = {
  supplierIndex: number;
  onClose: () => void;
  brands: IBrand[];
  suppliers: IAnonymizedSupplierPlatform[];
  countries: ICountry[];
};

function BestSourcingConfigurationModal({
  supplierIndex,
  onClose,
  brands,
  suppliers,
  countries,
}: Props) {
  const [step, setStep] = useState<'BEST_SOURCING_CONFIG' | 'SUPPLIER_CONFIG'>(
    'BEST_SOURCING_CONFIG',
  );

  return (
    <Modal.Container onClose={onClose} open={true} size='xl'>
      {step === 'BEST_SOURCING_CONFIG' ? (
        <GlobalConfiguration
          brands={brands}
          countries={countries}
          onClose={onClose}
          onOpenSupplierConfiguration={() => setStep('SUPPLIER_CONFIG')}
          supplierIndex={supplierIndex}
          suppliers={suppliers}
        />
      ) : (
        <SupplierConfiguration
          onBackToRankings={() => setStep('BEST_SOURCING_CONFIG')}
          supplierIndex={supplierIndex}
          suppliers={suppliers}
        />
      )}
    </Modal.Container>
  );
}

export default BestSourcingConfigurationModal;
